import { render, staticRenderFns } from "./TopFreelancer2.vue?vue&type=template&id=c2299760&scoped=true&"
import script from "./TopFreelancer2.vue?vue&type=script&lang=js&"
export * from "./TopFreelancer2.vue?vue&type=script&lang=js&"
import style0 from "./TopFreelancer2.vue?vue&type=style&index=0&id=c2299760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2299760",
  null
  
)

export default component.exports